"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EliteConciergeServices() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const photos = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1455.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1455.webp",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1455.webp",
    alt: "Luxury villa exterior in Los Cabos",
    stamp: "ASSET · 001",
    coords: "CABO 22.8905°N",
    rotate: "-6deg",
    span: "col-span-2 md:col-span-6 row-span-2 aspect-[3/4]",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1458.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1458.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1458.png",
    alt: "Private chef preparing a gourmet meal",
    stamp: "SERVICE · CHEF",
    coords: "FILED 01.22.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1460.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1459.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1459.png",
    alt: "Private yacht charter in the Sea of Cortez",
    stamp: "MARINE · ELITE",
    coords: "FILED 03.04.2024",
    rotate: "-3deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1475.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1475.webp",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1475.webp",
    alt: "Professional concierge management desk",
    stamp: "ADMIN · HUB",
    coords: "FILED 02.28.2024",
    rotate: "5deg",
    span: "col-span-1 md:col-span-3 row-span-2 aspect-[3/4]",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1473.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1473.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1473.png",
    alt: "IMI Elite Management office signage",
    stamp: "EST. 2010",
    coords: "FILED 04.09.2024",
    rotate: "-5deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1474-scaled.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1474-scaled.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1474-scaled.png",
    alt: "High-end resort lobby interior",
    stamp: "LOUNGE · LUX",
    coords: "FILED 03.18.2024",
    rotate: "3deg",
    span: "col-span-1 md:col-span-3 aspect-square",
    corner: "bottom-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1470.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1470.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1470.png",
    alt: "IMI Elite Management team in Los Cabos",
    stamp: "EQUIPO · CABO",
    coords: "FILED 05.01.2024",
    rotate: "-4deg",
    span: "col-span-2 md:col-span-6 row-span-2 aspect-[3/4]",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1469.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1469.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1469.png",
    alt: "Infinity pool maintenance inspection",
    stamp: "MAINT · POOL",
    coords: "FILED 04.22.2024",
    rotate: "6deg",
    span: "col-span-1 md:col-span-4 aspect-square",
    corner: "top-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1467.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1467.webp",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1467.webp",
    alt: "Legal real estate closing documents",
    stamp: "LEGAL · SAT",
    coords: "FILED 05.14.2024",
    rotate: "-7deg",
    span: "col-span-1 md:col-span-4 aspect-square",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1462-scaled.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1462-scaled.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1462-scaled.webp-wvc-sizes",
    alt: "Professional private chef preparing gourmet cuisine",
    stamp: "SERVICE · CHEF",
    coords: "FILED 06.15.2024",
    rotate: "2deg",
    span: "col-span-1 md:col-span-4 aspect-square",
    corner: "bottom-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1463.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1463.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1463.webp-wvc-sizes",
    alt: "Luxury catering service presentation",
    stamp: "SERVICE · CATERING",
    coords: "FILED 06.14.2024",
    rotate: "-5deg",
    span: "col-span-1 md:col-span-3 aspect-[3/4]",
    corner: "top-3 left-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1464.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1464.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1464.png-wvc-sizes",
    alt: "Elegant dining room asset",
    stamp: "ASSET · DINING",
    coords: "FILED 06.13.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-[3/4]",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1454.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1454.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1454.webp-wvc-sizes",
    alt: "Elite concierge service representative",
    stamp: "SERVICE · CONCIERGE",
    coords: "FILED 06.12.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-[3/4]",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1457.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1457.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1457.webp-wvc-sizes",
    alt: "Administrative archive and documentation",
    stamp: "ADMIN · ARCHIVE",
    coords: "FILED 06.11.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-[3/4]",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1456.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1456.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1456.png-wvc-sizes",
    alt: "Logistics and transportation service",
    stamp: "SERVICE · LOGISTICS",
    coords: "FILED 06.10.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-[3/4]",
    corner: "bottom-3 right-3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1471.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1471.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/IMG_1471.png-wvc-sizes",
    alt: "Luxury property asset in Los Cabos",
    stamp: "ASSET · LUXURY",
    coords: "FILED 06.09.2024",
    rotate: "4deg",
    span: "col-span-1 md:col-span-3 aspect-[3/4]",
    corner: "bottom-3 right-3"
  }];
  return <section data-section-id="1411" id="elite-concierge-services" className="bg-background text-foreground py-28 md:py-40 relative overflow-hidden">
      <style>{`
        @keyframes stamp-breathe {
          0%, 100% { transform: rotate(var(--stamp-rotate)) scale(1); }
          50% { transform: rotate(calc(var(--stamp-rotate) + 1.5deg)) scale(1); }
        }
        .stamp-idle { animation: stamp-breathe 6s ease-in-out infinite; }
        .photo-card:hover .stamp-idle {
          animation: none;
          transform: rotate(calc(var(--stamp-rotate) + 4deg));
          transition: transform 320ms cubic-bezier(0.22, 1, 0.36, 1);
        }
        .photo-img {
          transition: transform 320ms cubic-bezier(0.22, 1, 0.36, 1);
        }
        .photo-card:hover .photo-img {
          transform: scale(1.04);
        }
        .reveal {
          opacity: 0;
          transform: translateY(16px);
          transition: opacity 700ms cubic-bezier(0.22, 1, 0.36, 1), transform 700ms cubic-bezier(0.22, 1, 0.36, 1);
        }
        .reveal.is-visible {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: "repeating-radial-gradient(circle at 20% 30%, var(--foreground) 0, var(--foreground) 1px, transparent 1px, transparent 60px), repeating-radial-gradient(circle at 80% 70%, var(--foreground) 0, var(--foreground) 1px, transparent 1px, transparent 80px)"
    }} />

      <div className="relative mx-auto max-w-[1360px] px-6 md:px-10">
        <div ref={header.ref} className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24">
          <div className="md:col-span-5">
            <div className="font-mono uppercase text-xs md:text-sm mb-8 text-primary" style={{
            letterSpacing: "0.2em"
          }}>
              § 02 — Elite Concierge Services
            </div>
            <h2 className="font-serif font-default text-foreground" style={{
            fontSize: "clamp(2.25rem, 4.5vw, 4.5rem)",
            fontWeight: 600,
            letterSpacing: "-0.02em",
            lineHeight: 1.1
          }}>
              The Art of{" "}
              <em className="font-serif italic font-normal" style={{
              color: "var(--primary)"
            }}>
                Hospitality
              </em>
              .
            </h2>

            <div className="mt-10 flex items-center gap-3">
              <div className="h-px flex-1 bg-border" />
              <div className="w-1.5 h-1.5 rounded-md" style={{
              background: "var(--primary)"
            }} />
            </div>
          </div>

          <div className="md:col-span-7 flex flex-col md:items-end md:text-right justify-between gap-6">
            <div className="font-mono uppercase text-xs text-muted-foreground" style={{
            letterSpacing: "0.12em"
          }}>
              CATALOGED 2024 · 22.8905°N / 109.9167°W
            </div>
            <p className="font-default text-xs md:text-sm max-w-sm text-muted-foreground leading-relaxed" style={{
            letterSpacing: "0.01em"
          }}>
              A visual archive of IMI Elite Management operations.
              <br />
              Curated moments of luxury and precision in Los Cabos.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-3 md:gap-4 auto-rows-auto">
          {photos.map((photo, i) => {
          const reveal = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          return <div key={i} data-index={i} ref={reveal.ref} className={`reveal ${reveal.isVisible ? "is-visible" : ""} ${photo.span} photo-card group relative overflow-hidden rounded-md`} style={{
            transitionDelay: `${i % 4 * 80}ms`,
            background: "var(--card)",
            border: "1px solid var(--border)"
          }}>
                <div className="absolute inset-0 overflow-hidden">
                  <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" decoding="async" className="photo-img w-full h-full object-cover" style={{
                filter: "saturate(0.9) contrast(1.02)"
              }} />
                  <div aria-hidden="true" className="absolute inset-0 mix-blend-multiply" style={{
                background: "linear-gradient(180deg, hsla(220, 15%, 6%, 0.1) 0%, hsla(220, 15%, 6%, 0.4) 100%)"
              }} />
                  <div aria-hidden="true" className="absolute inset-0 opacity-[0.04] pointer-events-none mix-blend-overlay" style={{
                backgroundImage: "repeating-conic-gradient(var(--foreground) 0% 0.0001%, transparent 0.0001% 0.0002%)",
                backgroundSize: "3px 3px"
              }} />
                </div>

                <div className={`absolute ${photo.corner} z-10 stamp-idle`} style={{
              ["--stamp-rotate" as string]: photo.rotate,
              transform: `rotate(${photo.rotate})`
            } as React.CSSProperties}>
                  <div className="relative flex items-center justify-center" style={{
                width: "84px",
                height: "84px"
              }}>
                    <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" aria-hidden="true">
                      <defs>
                        <filter id={`rough-${i}`}>
                          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" />
                          <feDisplacementMap in="SourceGraphic" scale="1.5" />
                        </filter>
                      </defs>
                      <circle cx="50" cy="50" r="44" fill="none" stroke="var(--primary)" strokeWidth="2" filter={`url(#rough-${i})`} />
                      <circle cx="50" cy="50" r="36" fill="none" stroke="var(--primary)" strokeWidth="1" filter={`url(#rough-${i})`} />
                    </svg>
                    <div className="relative text-center px-2">
                      <div className="font-mono uppercase font-semibold leading-tight" style={{
                    color: "var(--primary)",
                    fontSize: "0.5rem",
                    letterSpacing: "0.1em"
                  }}>
                        {photo.stamp}
                      </div>
                      <div className="mt-1 w-4 h-px mx-auto" style={{
                    background: "var(--primary)"
                  }} />
                      <div className="font-mono uppercase mt-1" style={{
                    color: "var(--primary)",
                    fontSize: "0.4rem",
                    letterSpacing: "0.14em"
                  }}>
                        IMI
                      </div>
                    </div>
                  </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 z-10 flex items-end justify-between gap-2">
                  <div className="font-mono uppercase text-[0.6rem] md:text-[0.65rem] text-white/90" style={{
                letterSpacing: "0.12em"
              }}>
                    {photo.coords}
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="h-px w-6 bg-white/40" />
                    <div className="w-1 h-1 rounded-md" style={{
                  background: "var(--primary)"
                }} />
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-16 md:mt-24 flex items-center gap-3">
          <div className="font-mono uppercase text-xs text-muted-foreground" style={{
          letterSpacing: "0.16em"
        }}>
            END OF ARCHIVE · 16 ENTRIES
          </div>
          <div className="h-px flex-1 bg-border" />
          <div className="w-1.5 h-1.5 rounded-md" style={{
          background: "var(--primary)"
        }} />
        </div>
      </div>
    </section>;
}